/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { localStorageSingleton } from '@zcode/nr-utils'
import type { Dispatch } from 'redux'
import { setSavedCustomMessage } from '../../features/SavedCustomMessage'
import type { GetState } from '../../modules/types'

interface OneTapData {
  email?: string
  name?: string
  phone?: string | null
}

export const oneTapDataConflictsWithLoggedInUser =
  ({ email, name, phone }: OneTapData) =>
  (dispatch: Dispatch, getState: GetState) => {
    const user = getUser(getState())
    if (!user) {
      return false
    }
    if (
      (user.email && email && user.email.toLowerCase() !== email.toLowerCase()) ||
      (user.phone && phone && user.phone !== phone) ||
      (user.fullName && name && user.fullName.toLowerCase() !== name.toLowerCase())
    ) {
      localStorageSingleton.del('one_tap_form_inputs')
      dispatch(setSavedCustomMessage(undefined))
      return true
    }
    return false
  }
